import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Finance actor APIs (Points 7 & 8, Mudassir Jun-19).
const FinanceService = {
  getProfile: async () => {
    const res = await axiosInstance.get(API.finance.getProfile);
    return res.data;
  },
  updateProfile: async (payload) => {
    const res = await axiosInstance.put(API.finance.updateProfile, payload);
    return res.data;
  },
  // Work queue: expenses currently in Inprocess or Approved status.
  getQueue: async () => {
    const res = await axiosInstance.get(API.expenseManagement.financeList);
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  },
  // Approve (2) / Mark Paid (3) / Reject (4). finalAmount optional on reject.
  updateStatus: async (payload) => {
    const res = await axiosInstance.post(API.expenseManagement.financeUpdateStatus, payload);
    return res.data;
  },
  // Paid-expense report ({ period, data }), optional period + department filters.
  getPaymentsReport: async (periodType, referenceDate, departmentId) => {
    const url = API.expenseManagement.financePaymentsReport(periodType, referenceDate, departmentId);
    const res = await axiosInstance.get(url);
    return res.data;
  },
};

export default FinanceService;
